export default "__VITE_ASSET__DFmeX50j__"